export const SupplierTypeInput = [
    {key:'Agent', value:'Agent'},
    {key:'Dealer', value:'Dealer'},
    {key:'Farmer', value:'Farmer'},
]